import { format, parse } from 'fecha'
import TinyDatePicker from 'tiny-date-picker'
import 'tiny-date-picker/tiny-date-picker.css'

up.compiler('.date_picker', function(datePicker, data) {

  // The default date format is decided by Rails and handed to this compiler via 'up-data'.
  // Fallback formats are hardcoded.

  const settings = {
    mode: 'dp-below', // picker opens below text field
    dayOffset: 1, // week starts on monday
    format: function (date) { return format(date, data.format) },
    parse: function (string) { return parse(string, data.format) || parse(string, 'YYYY-M-D') || parse(string, 'YY-M-D') || parse(string, 'M-D') || new Date() },
  }

  const picker = TinyDatePicker(datePicker, settings)

  return function() {
    picker.destroy()
  }

})
